"use strict"

angular.module("customer")
.service("GoodsReceiptService", function($resource, FlashBag, appConfig) {
    this.READONLY_STATUSES = ["partial", "complete"];

    var resource = $resource(appConfig.API_SERVER + "/inventory/goods-receipts/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.create = function(data) {
        return (new resource(data)).$save();
    };

    this.query = function(params) {
        return resource.query(params);
    };

    this.get = function(id) {
        var params = {
            id: id
        };
        return resource.get(params);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/goods-receipt/goods-receipt.service.js
// module id = 954
// module chunks = 0